export type { CheckboxProps } from './Checkbox.types'
export { default as Checkbox } from './Checkbox'